import { IHolidayRegistry, IHolidayRepository } from "../../../domain/holiday";
import { HolidayRepository } from ".";

export class HolidayRegistry implements IHolidayRegistry {
  constructor(private _getToken: () => string) {
  }

  getHolidayRepository(): IHolidayRepository {
    return new HolidayRepository(this._getToken);
  }
}
